import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { useEffect, useState } from "react";
import { IconClockSolutionsSvg, IconMissionCriticalSpeedSvg } from "@/assets/images";

const { useBreakpoint } = Grid;

export function ServiceRoyalAirFreight({ royal_air_freight = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);

	return (
		<Container ref={ref}>
			<Row justify="center">
				<Col md={24} className={`${visible && "animate__animated animate__fadeInUp"}`}>
					<WrapperContent>
						<RATypography variant={screens?.xs ? "h3" : "h2"} align="center">
							{royal_air_freight?.title || ""}
						</RATypography>
					</WrapperContent>
					<Row justify="center">
						<Col xl={20} lg={20} md={20} sm={20} xs={22}>
							<RATypography variant="body3" top="8px" color="#595959" align="center">
								{royal_air_freight?.sub_title || ""}
							</RATypography>
						</Col>
					</Row>
				</Col>
			</Row>
			<WrapperSection>
				<Row gutter={[0, { xl: 60, lg: 40, md: 40, sm: 30, xs: 20 }]}>
					<Col span={24} className={`${visible && "animate__animated animate__zoomIn"}`}>
						<CardSectionItem
							name={royal_air_freight?.hight_light1?.title || ""}
							description={royal_air_freight?.hight_light1?.description || ""}
							image={royal_air_freight?.hight_light1?.photo || PATH_PUBLIC_IMAGES.service_af_freight_1}
							icon={<RAImage url={IconMissionCriticalSpeedSvg} width={44} height={44} />}
						/>
					</Col>
					<Col span={24} className={`${visible && "animate__animated animate__zoomIn"}`}>
						<CardSectionItem
							name={royal_air_freight?.hight_light2?.title || ""}
							description={royal_air_freight?.hight_light2?.description || ""}
							image={royal_air_freight?.hight_light2?.photo || PATH_PUBLIC_IMAGES.service_af_freight_2}
							reverse
							icon={<RAImage url={IconClockSolutionsSvg} width={44} height={44} />}
						/>
					</Col>
				</Row>
			</WrapperSection>
		</Container>
	);
}

const CardSectionItem = ({ name = "", description = "", image, reverse = false, icon }) => {
	const screens = useBreakpoint();
	return (
		<WrapperItem gutter={[0, 20]} align="middle">
			<Col
				sm={{
					span: 12,
					order: reverse ? 2 : 1,
				}}
				xs={{
					span: 24,
					order: 1,
				}}
				style={{
					paddingRight: screens?.xs ? "0" : reverse ? "0" : "40px",
					paddingLeft: screens?.xs ? "0" : reverse ? "40px" : "0",
				}}
			>
				<RAImage url={image} width="100%" height={screens.xs ? "210px" : "360px"} borderRadius="12px" />
			</Col>
			<Col
				sm={{
					span: 12,
					order: reverse ? 1 : 2,
				}}
				xs={{
					span: 24,
					order: 2,
				}}
			>
				<WrapperValues>
					{icon}
					<RATypography variant="sub-heading2" top={screens.xs ? "8px" : "16px"}>
						{name}
					</RATypography>
					<RATypography variant="body3" top={screens.xs ? "4px" : "10px"} color="#595959">
						{description}
					</RATypography>
				</WrapperValues>
			</Col>
		</WrapperItem>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
`;
const WrapperContent = styled.div`
	flex-direction: column;
	align-items: center;
`;
const WrapperValues = styled.div`
	@media (max-width: 576px) {
		padding: 16px 20px 20px;
	}
`;
const WrapperSection = styled.div`
	padding: 16px 0px;
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	@media (max-width: 576px) {
		margin-top: 0px;
	}
`;
const WrapperItem = styled(Row)`
	width: 100%;
	height: 100%;
	@media (max-width: 576px) {
		border-radius: 12px;
		background: #fff;
		box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.04);
	}
`;
